import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const sellerRouter: Array<RouteConfig> = [
  {
    path: "sellers_list",
    name: "sellers_accounts",
    component: () => import("@/views/Sellers/SellerList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_ADMIN]
    }
  },
  {
    path: "sellers_list/new_account",
    name: "new_seller_account",
    component: () => import("@/views/Sellers/NewAccount.vue"),
    meta: {
      permissionsRequired: [Permission.ADD_ADMIN]
    }
  },
  {
    path: "sellers_list/:id",
    name: "sellerId",
    component: () => import("@/views/Sellers/Seller.vue"),
    meta: {
      permissionsRequired: [Permission.EDIT_ADMIN]
    }
  }
];

export default sellerRouter;
